import {
    EDVISOR_LOGIN_SETSTATE,
    EDVISOR_LOGIN_AUTHENTICATION,
    EDVISOR_LOGIN_GETMENUDETAILS,
    EDVISOR_LOGIN_PAGERESET,
    EDVISOR_FORGOT_PASSWORD,
    EDVISOR_VERIFY_OTP,
    EDVISOR_RESET_PASSWORD
} from "./EdvisorLoginActionType";

const apiConfig = window as any;

const BASE_API_URL = apiConfig.BASE_API_URL?.charAt(apiConfig.BASE_API_URL.length - 1) === "/"
    ? apiConfig.BASE_API_URL.substring(0, apiConfig.BASE_API_URL.length - 1)
    : apiConfig.BASE_API_URL;

const BasicAuthentication = apiConfig.BasicAuthentication;

const postAuthorizedHeaders = {
    "Content-Type": "application/json",
    "Accept": "application/json",
    ...(BasicAuthentication ? { "Authorization": "Basic " + btoa(BasicAuthentication) } : {})
};

// Login authentication
export const EdvisorLogin = (loginRequest: { userID: string; userPassword: string }) => async (dispatch: any) => {
    try {
        const response = await fetch(
            `${BASE_API_URL}/EdvisorLogin`,
            {
                method: "POST",
                headers: postAuthorizedHeaders,
                body: JSON.stringify(loginRequest)
            }
        );
        const data = await response.json();

        // The API returns an array, but we'll handle it consistently
        const responseData = Array.isArray(data) && data.length > 0 ? data[0] : data;

        return dispatch({
            type: EDVISOR_LOGIN_AUTHENTICATION,
            payload: responseData
        });
    } catch (err) {
        console.error("Error in EdvisorLoginAction.ts > EdvisorLogin: " + err);
        return dispatch({
            type: EDVISOR_LOGIN_AUTHENTICATION,
            payload: {
                isSuccess: false,
                message: "Login failed. Please try again.",
                logInSuccess: false
            }
        });
    }
};

// Get menu details
export const GetMenuDetails = (loginRequest: { userID: string; userPassword: string }) => async (dispatch: any) => {
    try {
        const response = await fetch(
            `${BASE_API_URL}/ManuDetails`,
            {
                method: "POST",
                headers: postAuthorizedHeaders,
                body: JSON.stringify(loginRequest)
            }
        );
        const data = await response.json();

        return dispatch({
            type: EDVISOR_LOGIN_GETMENUDETAILS,
            payload: data
        });
    } catch (err) {
        console.error("Error in EdvisorLoginAction.ts > GetMenuDetails: " + err);
        return dispatch({
            type: EDVISOR_LOGIN_GETMENUDETAILS,
            payload: {
                success: false,
                message: "Failed to fetch menu details.",
                records: []
            }
        });
    }
};


// Forgot Password
export const EdvisorForgotPassword = (request: {
    userId: string;
    userType: string;
    applicationId: number;
}) => async (dispatch: any) => {
    try {
        const response = await fetch(
            `${BASE_API_URL}/ForgetPassword`,
            {
                method: "POST",
                headers: postAuthorizedHeaders,
                body: JSON.stringify({
                    userID: request.userId,
                    userType: request.userType,
                    applicationID: request.applicationId,
                }),
            }
        );
        const data = await response.json();
        // The API returns an object: { isSuccess: boolean, message: string, accessedOn: string }
        return dispatch({
            type: EDVISOR_FORGOT_PASSWORD,
            payload: data,
        });
    } catch (err) {
        console.error("Error in EdvisorLoginAction.ts > EdvisorForgotPassword: " + err);
        return dispatch({
            type: EDVISOR_FORGOT_PASSWORD,
            payload: {
                isSuccess: false,
                message: "Network error. Please try again.",
                accessedOn: null,
            },
        });
    }
};


// Verify OTP
export const EdvisorVerifyOtp = (request: {
    userId: string;
    userType: string;
    otp: string;
}) => async (dispatch: any) => {
    try {
        const response = await fetch(
            `${BASE_API_URL}/VerifyOtp`,
            {
                method: "POST",
                headers: postAuthorizedHeaders,
                body: JSON.stringify({
                    userID: request.userId,
                    userType: request.userType,
                    otp: request.otp,
                }),
            }
        );
        const data = await response.json();
        return dispatch({
            type: EDVISOR_VERIFY_OTP,
            payload: data,
        });
    } catch (err) {
        console.error("Error in EdvisorLoginAction.ts > EdvisorVerifyOtp: " + err);
        return dispatch({
            type: EDVISOR_VERIFY_OTP,
            payload: {
                isSuccess: false,
                message: "Network error. Please try again.",
            },
        });
    }
};


// Reset Password
export const EdvisorResetPassword = (request: {
    userId: string;
    userType: string;
    newPassword: string;
    confirmPassword: string;
}) => async (dispatch: any) => {
    try {
        const response = await fetch(
            `${BASE_API_URL}/ResetPassword`,
            {
                method: "POST",
                headers: postAuthorizedHeaders,
                body: JSON.stringify({
                    userID: request.userId,
                    userType: request.userType,
                    newPassword: request.newPassword,
                    confirmPassword: request.confirmPassword,
                }),
            }
        );
        const data = await response.json();
        return dispatch({
            type: EDVISOR_RESET_PASSWORD,
            payload: data,
        });
    } catch (err) {
        console.error("Error in EdvisorLoginAction.ts > EdvisorResetPassword: " + err);
        return dispatch({
            type: EDVISOR_RESET_PASSWORD,
            payload: {
                isSuccess: false,
                message: "Network error. Please try again.",
            },
        });
    }
};
// Set state
export const SetEdvisorLoginState = (param: any) => async (dispatch: any) => {
    return dispatch({
        type: EDVISOR_LOGIN_SETSTATE,
        payload: param
    });
};

// Reset login page
export const ResetEdvisorLoginPage = () => async (dispatch: any) => {
    return dispatch({
        type: EDVISOR_LOGIN_PAGERESET,
        payload: null
    });
};